import $ from 'jquery'
window.$ = $

const factor1 = '\\left(m_1x+k_1\\right)'
const factor2 = '\\left(m_2x+k_2\\right)'
katex.render(`${factor1}${factor2} = ax^2+bx+c`, $('h1')[ 0 ])
katex.render(`m_1=`, $('#m1-label')[ 0 ])
katex.render(`k_1=`, $('#k1-label')[ 0 ])
katex.render(`m_2=`, $('#m2-label')[ 0 ])
katex.render(`k_2=`, $('#k2-label')[ 0 ])

const GRID_SIZE = 11

const colHeaders = []
const rowHeaders = []
const productCells = []

let $hideAllBtn
let $showAllBtn

buildGrid()
populateGrid()

$('#coefficients input').change(populateGrid)

$('table#grid').on('click', 'td', e => {
  const $span = $(e.currentTarget).children('span')
  $span.css('visibility', $span.css('visibility') === 'hidden' ? 'visible' : 'hidden')
  updateShowHideBtnStates()
})

function buildGrid() {
  const $table = $('table#grid')
  let $tr
  let $th

  $tr = $('<tr>').appendTo($table)
  $th = $('<th>', { colspan: 2, rowspan: 2 }).appendTo($tr)

  $hideAllBtn = $('<a href="">Hide All</a>').appendTo($th)
  $hideAllBtn.click(e => {
    $('table#grid td > span').css('visibility', 'hidden')
    updateShowHideBtnStates()
    e.stopImmediatePropagation()
    e.stopPropagation()
    return false
  })

  $('<br>').appendTo($th)

  $showAllBtn = $('<a href="">Show All</a>').appendTo($th)
  $showAllBtn.click(e => {
    $('table#grid td > span').css('visibility', 'visible')
    updateShowHideBtnStates()
    e.stopImmediatePropagation()
    e.stopPropagation()
    return false
  })

  $th = $('<th>', { colspan: GRID_SIZE }).addClass('factor-title').appendTo($tr)
  katex.render(factor1, $th[ 0 ])

  $tr = $('<tr>').appendTo($table)
  for ( let col = 0; col < GRID_SIZE; col++ ) {
    const $th = $('<th class="factor-header">').appendTo($tr)
    colHeaders.push($th[ 0 ])
  }

  for ( let row = 0; row < GRID_SIZE; row++ ) {
    $tr = $('<tr>').appendTo($table)
    for ( let col = -1; col < GRID_SIZE; col++ ) {

      if ( row === 0 && col === -1 ) {
        $th = $('<th>', { rowspan: GRID_SIZE }).addClass('factor-title').appendTo($tr)
        katex.render(factor2, $th[ 0 ])
      } 

      const $cell = col === -1 || row === -1 ? $('<th class="factor-header">') : $('<td>')
      $cell.appendTo($tr)

      if ( col === -1 ) {
        rowHeaders.push($cell[ 0 ])
      } else {
        if ( row === 0 ) {
          productCells[ col ] = []
        }
        productCells[ col ][ row ] = $cell[ 0 ]
      }
    }
  }

  setTimeout(updateShowHideBtnStates, 0)
}

function populateGrid() {
  const m1 = Number($('#input-m1').val())
  const m2 = Number($('#input-m2').val())
  const k1Min = Number($('#input-k1').val()) - Math.floor(GRID_SIZE / 2)
  const k2Min = Number($('#input-k2').val()) - Math.floor(GRID_SIZE / 2)

  for ( let i = 0; i < GRID_SIZE; i++ ) {
    katex.render(headerText(m1, k1Min + i), colHeaders[ i ])
    katex.render(headerText(m2, k2Min + i), rowHeaders[ i ])
  }

  for ( let i = 0; i < GRID_SIZE; i++ ) {
    for ( let j = 0; j < GRID_SIZE; j++ ) {
      katex.render(product(m1, k1Min + i, m2, k2Min + j), productCells[ i ][ j ])
    }
  }
}

function headerText(m, k) {
  const s = product(m, k, 0, 1)
  return m === 0 || k === 0 ? s : `(${s})`
}

function product( m1, k1, m2, k2 ) {
  const a = m1 * m2
  const b = m1 * k2 + m2 * k1
  const c = k1 * k2

  let s = a === 0 ?
    '' :
    `${a < 0 ? '-' : ''}${Math.abs(a) === 1 ? '' : Math.abs(a)}x^2`

  if (b !== 0) {
    s += `${b < 0 ? '-' : s.length ? '+' : ''}${Math.abs(b) === 1 ? '' : Math.abs(b)}x`
  }

  if (c !== 0) {
    s += `${c < 0 ? '-' : s.length ? '+' : ''}${Math.abs(c)}`
  }

  return s || '0'
}

function updateShowHideBtnStates() {
  var showBtnVis = $('table#grid td > span').filter((i, span) => span.style.visibility === 'hidden').length
  var hideBtnVis = $('table#grid td > span').filter((i, span) => span.style.visibility !== 'hidden').length

  $showAllBtn.css('visibility', showBtnVis ? 'visible' : 'hidden')
  $hideAllBtn.css('visibility', hideBtnVis ? 'visible' : 'hidden')
}
